import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;
    h1 {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.3rem;
      margin: 0;
    }
  }
  svg {
    height: 2rem;
    fill: ${({ theme }) => theme.colors.secondary};
  }
  button {
    color: ${({ theme }) => theme.colors.background_white};
    background: ${({ theme }) => theme.colors.tertiary_500};
    border: none;
    border-radius: 2rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Content = styled.div`
  .containerButton {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-end;
  }
`;
